import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { ParsedExperimentVariants } from '../utils/multivariateExperimentUtils';

export interface MultivariateExperimentState {
  home: string;
  // goldCoinPlp: string;
  plp: string;
  pdp: string;
  guestCheckout: string;
  rawCookies: Record<string, string>;
}

const initialState: MultivariateExperimentState = {
  home: 'NONE',
  // goldCoinPlp: 'NONE',
  plp: 'NONE',
  pdp: 'NONE',
  guestCheckout: 'NONE',
  rawCookies: {},
};

export const multivariateExperimentSlice = createSlice({
  name: 'multivariateExperiment',
  initialState,
  reducers: {
    setExperimentVariants(state, action: PayloadAction<Partial<ParsedExperimentVariants>>) {
      if (action.payload.home !== undefined) {
        state.home = action.payload.home;
      }
      // if (action.payload.goldCoinPlp !== undefined) {
      //   state.goldCoinPlp = action.payload.goldCoinPlp;
      // }
      if (action.payload.plp !== undefined) {
        state.plp = action.payload.plp;
      }
      if (action.payload.pdp !== undefined) {
        state.pdp = action.payload.pdp;
      }
      if (action.payload.guestCheckout !== undefined) {
        state.guestCheckout = action.payload.guestCheckout;
      }
      if (action.payload.rawCookies) {
        state.rawCookies = action.payload.rawCookies;
      }
    },
    resetExperimentVariants() {
      return initialState;
    },
  },
});

export const { setExperimentVariants, resetExperimentVariants } = multivariateExperimentSlice.actions;
export const multivariateExperimentReducer = multivariateExperimentSlice.reducer;
export const MULTIVARIATE_EXPERIMENT_SLICE_NAME = multivariateExperimentSlice.name;
